import React, { useState } from "react";
import { Checkbox, Stack, Typography } from "@mui/material";

import { printZpl, useAvailablePrinters } from "../../utils/zplBarcode";
import PrinterListSkeleton from "./PrinterListSkeleton";

import { HubIcon } from "../HubIcon";
import { HubButton } from "../inputs";

import { PrinterStack } from "./styles";
import { useHubSnackBar } from "../../hooks";

export const PrinterList = ({ getZpl = () => {} }) => {
  const [selected, setSelected] = useState(0);

  const { data, isLoading } = useAvailablePrinters();

  const PRINTERS = data?.map((p, idx) => ({
    id: idx,
    label: p.name.length >= 45 ? `${p.name.substring(0, 42)}...` : p.name,
    device: p,
  }));

  const handleSelect = (e, idx) => {
    e.preventDefault();
    e.stopPropagation();
    setSelected(idx === selected ? null : idx);
  };

  const snackbar = useHubSnackBar();
  const handleSubmit = () => {
    if (typeof selected != "number") return;

    const printer = PRINTERS.find((p) => p.id === selected);
    const device = printer?.device;
    const file = getZpl();
    const payload = { file, device, snackbar };
    printZpl(payload);
  };

  const disabled = typeof selected != "number" || !data?.length;

  return (
    <Stack gap="2px" justifyContent="center" width="100%" minWidth="250px">
      <Stack
        padding="10px 15px"
        direction="row"
        gap="5px"
        borderBottom="1px solid"
        borderColor="hubColors.greyLight"
        alignItems="center"
      >
        <HubIcon icon="Printer" size={12} />
        <Typography variant="caption">Printers</Typography>
      </Stack>
      <Stack
        justifyContent="center"
        alignItems="center"
        width="100%"
        padding="7px 0px"
        minHeight="45px"
      >
        {isLoading ? (
          <PrinterListSkeleton />
        ) : PRINTERS?.length ? (
          PRINTERS?.map((p) => {
            const isChecked = selected === p.id;
            const handleCheck = (e) => handleSelect(e, p.id);
            return (
              <PrinterStack
                key={p.id}
                selected={isChecked}
                onClick={handleCheck}
              >
                <Checkbox
                  checked={isChecked}
                  onClick={handleCheck}
                  sx={{ padding: 0 }}
                />
                <Typography variant="caption">{p?.label}</Typography>
              </PrinterStack>
            );
          })
        ) : (
          <Stack padding="5px" alignItems="center" justifyContent="center">
            <Typography variant="caption">No Printers Found</Typography>
          </Stack>
        )}
      </Stack>
      <Stack
        padding="10px"
        direction="row"
        gap="5px"
        borderTop="1px solid"
        borderColor="hubColors.greyLight"
        alignItems="center"
        justifyContent="end"
      >
        <HubButton
          variant="contained"
          size="xsmall"
          label="Print"
          disabled={disabled}
          onClick={handleSubmit}
        />
      </Stack>
    </Stack>
  );
};

export default PrinterList;
